<template>
  <div>
    <h1 class="font-md bold-medium ion-padding-bottom">{{ t('announcement.thisPlace') }}</h1>
    <ion-row
      v-for="feature in features"
      class="ion-justify-content-start ion-align-items-center price-subtitle nowrap my-sm"
      :key="feature.id"
    >
      <PropertyImage :feature="feature" :language="language" />
    </ion-row>
  </div>
</template>

<script setup lang="ts">
  import { IonRow } from '@ionic/vue';
  import { ContractModelRelation } from '@/interfaces/elastic/elastic.interface';
  import { useI18n } from 'vue-i18n';
  import PropertyImage from '@/components/announcement/PropertyImage.vue';

  const { t } = useI18n();

  withDefaults(
    defineProps<{
      features: ContractModelRelation[];
      language: string;
    }>(),
    {},
  );
</script>

<style lang="css" scoped>
  ion-accordion {
    border: 1px solid var(--ion-color-light);
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }
</style>
